import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthRolesInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const encryptedRoles = localStorage.getItem('encryptedRoles');
    if(encryptedRoles) {
      const cloned=request.clone({
        setHeaders: {
          'X-User-Roles': encryptedRoles
        }
      });
      return next.handle(cloned);
    }
    return next.handle(request);
  }
}